// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h2 id="argonaut-data-query">Argonaut Data Query</h2>
      <p>The Argonaut Project is a joint project of major US EHR vendors to advance industry adoption of modern, open interoperability standards. VA’s FHIR Argonaut Data Query API is based upon the FHIR DSTU-2 specification, particularly the <a href="http://www.fhir.org/guides/argonaut/r2/index.html">Argonaut Data Query Implementation Guide</a>. As noted in the implementation guide, the resources and requirements supported by Argonaut are a subset of those profiles included in DSTU-2.</p>
      <p>The profiles included in VA’s Argonaut Data Query API are compliant with the FHIR Argonaut Data Query Implementation Guide and satisfy the following two following use cases:</p>
      <ul>
      <li>Patient uses provider-approved web application to access health data</li>
      <li>Patient uses provider-approved mobile app to access health data</li>
      </ul>
    </div>
  );
};

export default MarkdownComponent;
